// views/Dashboard/PainelExecutivo/components/SeletorContagemFunil.tsx
import React from 'react';
import type { ContagemFunil } from '../types';
import InfoTip from '../../../../src/components/InfoTip';

/**
 * Como o funil do Comercial conta: pela data de cada etapa (o padrão) ou só o
 * que teve a jornada inteira dentro do período. Fica à vista, ao lado do canal:
 * os dois modos dão números bem diferentes para o mesmo mês.
 */
const SeletorContagemFunil: React.FC<{
  valor: ContagemFunil;
  onChange: (v: ContagemFunil) => void;
  /** O período é um mês só? Muda só o rótulo ("no mês" × "no período"). */
  umMes: boolean;
}> = ({ valor, onChange, umMes }) => {
  const recorte = umMes ? 'mês' : 'período';
  const opcoes: { valor: ContagemFunil; rotulo: string; titulo: string }[] = [
    { valor: 'evento', rotulo: 'Pela data da etapa', titulo: 'Cada etapa conta pela data em que aconteceu, venha a negociação de que mês vier.' },
    { valor: 'jornada', rotulo: `Só o que aconteceu no ${recorte}`, titulo: `Só conta a negociação que teve todas as etapas, da criação até a do card, dentro do ${recorte}.` },
  ];
  return (
    // flex-wrap: no celular os dois botões não cabem ao lado do rótulo.
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Contar</span>
      <div className="flex items-center gap-1 rounded-full bg-gray-100 dark:bg-gray-800 p-1">
        {opcoes.map((o) => (
          <button
            key={o.valor}
            type="button"
            onClick={() => onChange(o.valor)}
            aria-pressed={valor === o.valor}
            title={o.titulo}
            className={`rounded-full px-3 py-1.5 text-xs font-semibold whitespace-nowrap transition-colors ${
              valor === o.valor ? 'bg-primary text-white' : 'text-gray-500 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700'
            }`}
          >
            {o.rotulo}
          </button>
        ))}
      </div>
      <InfoTip label="O que muda entre as duas contagens">
        <p>
          <strong>Pela data da etapa</strong>: um termo enviado em setembro e assinado em outubro entra em
          "Termo Assinado" de outubro. É o que aconteceu no {recorte}, venha de onde vier.
        </p>
        <p className="mt-1">
          <strong>Só o que aconteceu no {recorte}</strong>: a negociação só conta se todas as etapas, da criação do
          lead até a do card, caíram dentro do {recorte}. Cada card fica dentro do anterior. Lead criado no fim do
          {' '}{recorte} anterior e fechado agora fica de fora.
        </p>
      </InfoTip>
    </div>
  );
};

export default SeletorContagemFunil;
